<template>
  <div>
    <vx-card class="no-scroll-content" title="Supervisors">
      <vs-tabs position="left">
        <vs-tab
          v-for="(supervisor, index) in supervisors"
          :key="index"
          :label="supervisor.name"
          @click="activateTab(index)"
        >
          <vs-tabs class="employee-tabs">
            <vs-tab
              v-for="(user, userIndex) in getUsersBySupervisorId(supervisor.id)"
              :key="userIndex"
              :label="user.name"
              @click="logEmployeeId(user.id, supervisor.id)"
              :active="activeUsers[supervisor.id] === user.id"
            >
              <!-- Display selected employee name beside the vs-tab -->
              <MyPeopleInformation
                :activeUser="activeUsers[supervisor.id]"
                :getEmployeeName="getEmployeeName"
              />
            </vs-tab>
          </vs-tabs>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import MyPeopleInformation from "./MyPeopleInformation.vue";
export default {
  data() {
    return {
      activeUsers: {}, // Object to store active user ID for each supervisor
      supervisors: [
        { id: 1, name: "Francis Austria" },
        { id: 2, name: "MarshMello" },
      ],
      employees: [
        { id: 2, name: "Emily Johnson", role: "user", supervisorid: 1 },
        { id: 3, name: "Mello Davis", role: "user", supervisorid: 1 },
        { id: 4, name: "Sarah Smith", role: "user", supervisorid: 1 },
        { id: 5, name: "David Goliath", role: "user", supervisorid: 2 },
        { id: 6, name: "Jaylem Bryant", role: "user", supervisorid: 2 },
        { id: 7, name: "Jessica Loves", role: "user", supervisorid: 2 },
      ],
    };
  },
  mounted() {
    // Select the initial employees for each supervisor
    this.supervisors.forEach((supervisor) => {
      const initialEmployee = this.getInitialEmployeeBySupervisorId(
        supervisor.id
      );
      if (initialEmployee) {
        this.$set(this.activeUsers, supervisor.id, initialEmployee.id);
      }
    });
  },
  methods: {
    getUsersBySupervisorId(supervisorId) {
      return this.employees.filter(
        (employee) =>
          employee.supervisorid === supervisorId && employee.role === "user"
      );
    },
    getInitialEmployeeBySupervisorId(supervisorId) {
      const employees = this.getUsersBySupervisorId(supervisorId);
      return employees.length > 0 ? employees[0] : null;
    },
    logEmployeeId(employeeId, supervisorId) {
      this.$set(this.activeUsers, supervisorId, employeeId);
      console.log("Selected Employee ID:", employeeId);
    },

    getEmployeeName(employeeId) {
      const employee = this.employees.find((emp) => emp.id === employeeId);
      return employee ? employee.name : "Employee not found";
    },
  },
  components: {
    MyPeopleInformation,
  },
};
</script>

<style lang="scss" scoped>
.employee-tabs {
  display: flex;
}
</style>
